export const getAuthToken = () => {
    return window.TOLOKA_AUTH_TOKEN;
};

// TODO remove this in the future
export const getDefaultAuthToken = () =>
    'Fbckp3TCYx32AaNYWQjLMg.045e.e4LzkGTlNr3lKPGxUU0FTztzabkFGrMwm9m6NsGHKw9anx6TX-EXmNLXS42trQGMJbR4GsqZqz-R6t0QUG4YsAgoj-Uv8BBW-1M6yD_35kM';

export const getMondaySubitemId = (): number => {
    return window.TB_MONDAY_SUBITEM_ID;
};

export const setAuthTokenHook = (request: Request) => {
    const apiToken = getAuthToken();

    if (apiToken) {
        request.headers.set('Authorization', `ApiKey ${apiToken}`);
    }
};

export const setMondayIdHook = (request: Request) => {
    if (request.headers.has('MONDAY-SUBITEM-ID')) return;

    const mondaySubitemId = getMondaySubitemId();

    if (mondaySubitemId) {
        request.headers.set('MONDAY-SUBITEM-ID', `${mondaySubitemId}`);
    }
};
